export * from './base-apollo.service';
